import { useState, useEffect, useMemo } from "react";
import styles from './users.module.css';
import { Link, useNavigate } from "react-router-dom";
import { adminAPI } from '../utils/adminAPI';

export const UserManagement = () => {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'asc' });

    
 /*    const fakeUser = [

        {
            created_at: "2025-08-18T19:25:28.000Z",
            current_trip_id: 20,
            email: "2048yossi@gmail.com",
            email_verified: false,
            firstname: "joseph",
            id: 31,
            is_active: true,
            last_login: null,
            lastname: "goldberger",
            role: "user",
            token_expires_at: null,
            updated_at: "2025-08-18T19:25:28.000Z",
            verification_token: null
        }

    ] */



    async function fetchAndRenderAllData() {
        try {
            const data = await adminAPI.users();
            console.warn(data);
            setUsers(data.users);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    useEffect(()=>{
        fetchAndRenderAllData();
    },[])

    const processedUsers = useMemo(() => {
        const term = searchTerm.trim().toLowerCase();
        let filtered = users;
        if (term) {
            filtered = users.filter(u => {
                return (
                    String(u.firstname || '').toLowerCase().includes(term) ||
                    String(u.lastname || '').toLowerCase().includes(term) ||
                    String(u.email || '').toLowerCase().includes(term) ||
                    String(u.id || '').toLowerCase().includes(term)
                );
            });
        }

        const { key, direction } = sortConfig;
        const sorted = [...filtered].sort((a, b) => {
            const va = a[key] ?? '';
            const vb = b[key] ?? '';
            // numeric compare for id
            if (key === 'id') {
                return (Number(va) - Number(vb)) * (direction === 'asc' ? 1 : -1);
            }
            const sa = String(va).toLowerCase();
            const sb = String(vb).toLowerCase();
            if (sa < sb) return direction === 'asc' ? -1 : 1;
            if (sa > sb) return direction === 'asc' ? 1 : -1;
            return 0;
        });
        return sorted;
    }, [users, searchTerm, sortConfig]);


    async function deleteUser(userId, firstName) {
        // Implement user deletion logic here
        console.log(`Delete user with ID: ${userId}`);

        if (confirm('Are you sure you want to delete ' + firstName + '?')) {
            console.log('User with ID ' + userId + ' deleted');
            try {
                await adminAPI.deleteUser(userId);
                setUsers(users.filter(user => user.id !== userId));
            } catch (error) {
                console.error("Error deleting user:", error);
            }
        }
    }
    return (<>
        <main className={styles.main}>
            <div className={styles.pageHeader}>
                <Link to="/admin" className={styles.adminLink}>Go Back</Link>
                <h2 className={styles.h2}>User Management</h2>
                <div className={styles.adminLink} style={{visibility: 'hidden'}}></div>
            </div>

            <div className={styles.controls}>
                
              <div className={styles.searchControl}>
                    <input
                    type="search"
                    placeholder="Search by name, email or id"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <button onClick={() => setSearchTerm('')} title="Clear search">
                    Clear
                </button>

                </div>
                <div className={styles.sortControl}>
                    <label>
                    <span>Sort:</span>
                    <select value={sortConfig.key} onChange={(e) => setSortConfig(prev => ({...prev, key: e.target.value}))}>
                        <option value="id">ID</option>
                        <option value="firstname">First Name</option>
                        <option value="lastname">Last Name</option>
                        <option value="email">Email</option>
                        <option value="role">Role</option>
                    </select>
                </label>
                <button onClick={() => setSortConfig(prev => ({...prev, direction: prev.direction === 'asc' ? 'desc' : 'asc'}))}>
                    {sortConfig.direction === 'asc' ? 'Asc ▲' : 'Desc ▼'}
                </button>

                </div>
                
                <div style={{ fontSize: 17, color: '#666'}}>
                    {processedUsers.length} user{processedUsers.length !== 1 ? 's' : ''}
                </div>
            </div>

            <table className={styles.userTable}>
                <thead>
                    <tr>
                        <th style={{cursor: 'pointer'}} onClick={() => {
                            setSortConfig(prev => prev.key === 'id' ? {...prev, direction: prev.direction === 'asc' ? 'desc' : 'asc'} : {...prev, key: 'id', direction: 'asc'});
                        }}>
                            ID {sortConfig.key === 'id' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                        </th>
                        <th style={{cursor: 'pointer'}} onClick={() => {
                            setSortConfig(prev => prev.key === 'firstname' ? {...prev, direction: prev.direction === 'asc' ? 'desc' : 'asc'} : {...prev, key: 'firstname', direction: 'asc'});
                        }}>
                            First Name {sortConfig.key === 'firstname' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                        </th>
                        <th style={{cursor: 'pointer'}} onClick={() => {
                            setSortConfig(prev => prev.key === 'lastname' ? {...prev, direction: prev.direction === 'asc' ? 'desc' : 'asc'} : {...prev, key: 'lastname', direction: 'asc'});
                        }}>
                            Last Name {sortConfig.key === 'lastname' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                        </th>
                        <th style={{cursor: 'pointer'}} onClick={() => {
                            setSortConfig(prev => prev.key === 'email' ? {...prev, direction: prev.direction === 'asc' ? 'desc' : 'asc'} : {...prev, key: 'email', direction: 'asc'});
                        }}>
                            Email {sortConfig.key === 'email' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                        </th>
                        <th style={{cursor: 'pointer'}} onClick={() => {
                            setSortConfig(prev => prev.key === 'role' ? {...prev, direction: prev.direction === 'asc' ? 'desc' : 'asc'} : {...prev, key: 'role', direction: 'asc'});
                        }}>
                            Role {sortConfig.key === 'role' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                        </th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {processedUsers.length === 0 ? (
                        <tr key="no-results">
                            <td colSpan={6} style={{textAlign: 'center', padding: '18px 8px'}}>No users found.</td>
                        </tr>
                    ) : (
                        processedUsers.map((user) => (
                            <tr key={user.id} style={{cursor: 'pointer'}} onClick={() => navigate(`/admin/users/${user.id}`)}>
                                <td>{user.id}</td>
                                <td>{user.firstname}</td>
                                <td>{user.lastname}</td>
                                <td>{user.email}</td>
                                <td>{user.role}</td>
                                <td onClick={(e) => e.stopPropagation()}>
                                    <button onClick={() => deleteUser(user.id, user.firstname)}>Delete</button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>


</main>
      
    </>)
}